// extracted by mini-css-extract-plugin
module.exports = {"root":"AgritourismStatutes_root__2A3rZ","anchor":"AgritourismStatutes_anchor__FyjuE","agriLink":"AgritourismStatutes_agriLink__xehou"};